export const cadastro = {
  'isAceiteTermoDeCompromisso': null,
  'codigo': '',
  'dataCadastro': '',
  'dataAtualizacao': '',
  'versao': '',
  'hash': '',
  'situacao': '',
  'isMultiplosInteressados': null,
  'cadastrante': {
    'pessoa': {
      'isPessoaFisica': null,
      'pessoaFisica': {
        'cpf': '',
        'nome': ''
      },
      'pessoaJuridica': {
        'cnpj': '',
        'razaoSocial': ''
      },
      'endereco': {
        'logradouro': '',
        'semNumero': null,
        'numero': '',
        'complemento': '',
        'bairro': '',
        'cep': '',
        'idMunicipio': '',
        'municipio': {
          'nome': '',
          'estadoCod': ''
        }
      },
      'email': '',
      'telefones': []
    }
  },
  'georreferenciamento': {
    'jsonPlanilha': '',
    'tipoPlanilha': '',
    'denominacao': '',
    'possuiGeorreferenciamento': '',
    'localizacoes': [],
    'documentos': [],
    'documentosRemovidos': [],
    'responsavel': {
      'nome': '',
      'formacao': '',
      'creaRnp': '',
      'codigoIncra': ''
    }
  },
  'imovel': {
    'numeroReciboCar': '',
    'area': null,
    'descricaoAcesso': '',
    'possuiCar': null,
    'idMunicipio': '',
    'municipio': null,
    'tempoOcupacao': '',
    'ocupantesAnteriores': null,
    'conflitos': null,
    'numeroProcessoJudicial': '',
    'termo': '',
    'finalidades': [],
    'cnsMatricula': '',
    'numeroMatricula': '',
    'livroMatricula': '',
    'numeroFolhaMatricula': '',
    'nomeBeneficiarioTitulo': '',
    'numeroTitulo': '',
    'areaTitulo': '',
    'dataExpedicaoTitulo': '',
    'modalidadeTitulo': ''
  },
  'destinacaoUsoImovel': {
    'abaAtiva': '',
    'agricultura': '',
    'pecuaria': '',
    'servidaoAmbiental': '',
    'silvicultura': '',
    'sistemasAgroflorestais': '',
    'outros': '',
    'descricaoOutros': '',
    'possuiReservaLegal': '',
    'areaReservaLegal': '',
    'percentualAreaReservalegal': '',
    'produtividade': {
      'possuiComprovante': null,
      'tipo': '',
      'dap': '',
      'drp': '',
      'documentos': []
    },
    'semoventes': [],
    'culturasPermanentes': [],
    'culturasTemporarias': [],
    'silviculturas': [],
    'manejosFlorestais': [],
    'outrasAtividades': [],
    'edificacoes': []
  },
  'interessado': {
    'perguntasQualificativas': {
      'cargoPublico': null,
      'possuiImovelRuralTitulado': null,
      'ocupaImovel': null,
      'exploracaoAgricola': null
    },
    'situacao': '',
    'usaDadosCadastrante': null,
    'pessoa': {
      'isPessoaFisica': null,
      'email': '',
      'telefones': [],
      'endereco': {
        'logradouro': '',
        'semNumero': null,
        'numero': '',
        'complemento': '',
        'bairro': '',
        'cep': '',
        'municipios': [],
        'municipio': {
          'nome': '',
          'estado': '',
          'id': ''
        }
      },
      'pessoaJuridica': {
        'razaoSocial': null,
        'cnpj': null
      },
      'pessoaFisica': {
        'cpf': '',
        'nome': '',
        'apelido': '',
        'rg': '',
        'nacionalidade': '',
        'estadoCivil': '',
        'descEstadoCivil': '',
        'codigoOrgaoExpedidor': '',
        'estadoOrgaoExpedidor': '',
        'naturalidade': {
          'municipio': {
            'id': null
          }
        },
        'orgaoExpedidor': {
          'codigo': '',
          'estado': ''
        },
        'dataNascimento': ''
      }
    },
    'conjuge': {
      'pessoa': {
        'isPessoaFisica': null,
        'pessoaJuridica': {
          'cnpj': '',
          'razaoSocial': ''
        },
        'pessoaFisica': {
          'cpf': '',
          'nome': '',
          'rg': '',
          'temCertidaoObito': '',
          'dataNascimento': '',
          'codigoOrgaoExpedidor': '',
          'estadoOrgaoExpedidor': '',
          'nacionalidade': '',
          'naturalidade': {
            'codigoEstado': '',
            'municipio': {
              'id': null
            }
          },
          'orgaoExpedidor': {
            'codigo': '',
            'estado': ''
          }
        }
      }
    },
    'documentos': [],
    'sociosRepresentantesLegais': [],
    'idsSociosRepresentantes': []
  },
  'interessados': {
    'interessadosLista': [],
    'interessadosListaRemovidos': [],
    'paginacao': {
      'paginaAtual': null,
      'tamanhoMaximo': null,
      'totalRegistros': null
    }
  },
  'qualificacao': {
    'area': null,
    'renda': '',
    'cargoPublico': null,
    'possuiImovelRuralTitulado': null,
    'ocupaImovel': null,
    'exploracaoAgricola': null
  },
  'despacho': '',
  'membrosComunidadeLista': [],
  'representantes': {
    'itens': []
  },
  'beneficiarios': {
    'beneficiariosLista': []
  }
}



// WEBPACK FOOTER //
// ./src/utils/ma/cadastro.js